import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { LayoutProvider } from './contexts/LayoutContext';
import ForceChangePasswordModal from './components/ForceChangePasswordModal';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <LayoutProvider>
          <AppRoutes />
          <ForceChangePasswordModal />
        </LayoutProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
